var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "migrate-destinations"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('fieldset', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "header"
  }), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('legend', {
    staticStyle: {
      "background-color": "#c2cfd6"
    }
  }, [_vm._v("Migrate Destinations")]), _vm._v(" "), _c('b-card', [_c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Source City"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-home'></i>"
    }
  }, [_c('b-input-group', [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('sourcecityid')
    },
    attrs: {
      "options": _vm.cityList,
      "selected-option": _vm.sourcecityObjData,
      "name": "sourcecityid",
      "placeholder": "Select Source City"
    },
    on: {
      "select": _vm.selectedSource
    },
    model: {
      value: (_vm.sourcecityid),
      callback: function($$v) {
        _vm.sourcecityid = $$v
      },
      expression: "sourcecityid"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('sourcecityid')),
      expression: "errors.has('sourcecityid')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Source City field is\n                    required.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isSourceLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isSourceLoading = $event
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Source Group"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-group'></i>"
    }
  }, [_c('b-input-group', [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('sourceGroupNo')
    },
    attrs: {
      "options": _vm.sourceGroupNoList,
      "selected-option": _vm.sourceGroupNoObjData,
      "name": "sourceGroupNo",
      "placeholder": "Select Source Group"
    },
    on: {
      "select": _vm.selectedSourceGroupNo
    },
    model: {
      value: (_vm.sourceGroupNo),
      callback: function($$v) {
        _vm.sourceGroupNo = $$v
      },
      expression: "sourceGroupNo"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('sourceGroupNo')),
      expression: "errors.has('sourceGroupNo')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Source Group field is\n                    required.")]), _vm._v(" "), _c('span', {
    staticClass: "text-danger",
    staticStyle: {
      "font-size": "0.9em"
    }
  }, [_vm._v(_vm._s(_vm.sourceGroupListError))])], 1)]), _vm._v(" \n              "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12",
    style: (("" + ((_vm.destinationList.length>0) ? 'overflow: auto; height: 450px;':'overflow: auto; height: 200px;')))
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_vm._v("\n                      Total Mapped Destinations : " + _vm._s(_vm.totalmappedhubs) + "\n                    ")])]), _vm._v(" "), _c('fieldset', [_c('b-card', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [(_vm.showList == true) ? _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-university'></i>"
    }
  }, [_c('model-select', {
    class: {
      'form-control': true
    },
    staticStyle: {
      "overflow": "visible"
    },
    attrs: {
      "options": _vm.listHubZoneData,
      "name": "hubzoneid",
      "title": "Select Zone",
      "placeholder": "Select Zone"
    },
    on: {
      "input": function($event) {
        return _vm.selectedZone()
      }
    },
    model: {
      value: (_vm.hubzoneid),
      callback: function($$v) {
        _vm.hubzoneid = $$v
      },
      expression: "hubzoneid"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.zoneLoading))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [(_vm.showList == true) ? _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-university'></i>"
    }
  }, [_c('model-select', {
    class: {
      'form-control': true
    },
    staticStyle: {
      "overflow": "visible"
    },
    attrs: {
      "options": _vm.listHubData,
      "name": "hubid",
      "title": "Select Hub",
      "placeholder": "Select Hub"
    },
    on: {
      "input": function($event) {
        return _vm.selectedHub()
      }
    },
    model: {
      value: (_vm.hubid),
      callback: function($$v) {
        _vm.hubid = $$v
      },
      expression: "hubid"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.hubLoading))])], 1), _vm._v(" "), (_vm.showList == true) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    staticClass: "text-center",
    staticStyle: {
      "cursor": "pointer",
      "font-size": "16px",
      "float": "left",
      "margin-top": "7px"
    },
    on: {
      "click": function($event) {
        return _vm.resetZoneHub()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "title": "Reset Zone/Hub"
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.destinationLoading
    },
    on: {
      "update:active": function($event) {
        _vm.destinationLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    class: ("" + ((_vm.destinationList.length>0) ? 'showdest' : '')),
    style: (("" + ((_vm.destinationList.length>0) ? 'margin-top: 1%;height: 330px;' : 'margin-top: 1%;overflow:auto; min-height:auto;')))
  }, [_c('table', {
    staticClass: "table-hover datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-left tableheader",
    attrs: {
      "colspan": "4"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkAllHub),
      expression: "checkAllHub"
    }],
    staticStyle: {
      "cursor": "pointer",
      "margin-left": "10px"
    },
    attrs: {
      "type": "checkbox",
      "id": "all"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkAllHub) ? _vm._i(_vm.checkAllHub, null) > -1 : (_vm.checkAllHub)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.checkAllHub,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkAllHub = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkAllHub = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkAllHub = $$c
        }
      }, _vm.checkHub]
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "for": "all"
    }
  }, [_vm._v(" Select All")])])])]), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "z-index": "-1"
    }
  }, [_vm._l((_vm.destinationList), function(destination) {
    return _c('tr', _vm._l((destination), function(hub, index) {
      return _c('td', [_c('input', {
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "type": "checkbox",
          "id": hub.hubId
        },
        domProps: {
          "checked": _vm.checkedHub[hub.hubId]
        },
        on: {
          "change": _vm.updateCheckDest
        }
      }), _vm._v(" "), _c('label', {
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "for": hub.hubId
        }
      }, [_vm._v(" " + _vm._s(hub.hubName) + "\n                                  (" + _vm._s(hub.hubId) + ")")])])
    }), 0)
  }), _vm._v(" "), (_vm.destinationList.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Target City"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-home'></i>"
    }
  }, [_c('b-input-group', [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('targetcityid')
    },
    attrs: {
      "options": _vm.cityList,
      "selected-option": _vm.targetcityObjData,
      "name": "targetcityid",
      "placeholder": "Select Target City"
    },
    on: {
      "select": _vm.selectedTarget
    },
    model: {
      value: (_vm.targetcityid),
      callback: function($$v) {
        _vm.targetcityid = $$v
      },
      expression: "targetcityid"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('targetcityid')),
      expression: "errors.has('targetcityid')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Target City field is\n                    required.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isTargetLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isTargetLoading = $event
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Target Group"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-group'></i>"
    }
  }, [_c('b-input-group', [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('targetGroupNo')
    },
    attrs: {
      "options": _vm.targetGroupNoList,
      "selected-option": _vm.targetGroupNoObjData,
      "name": "targetGroupNo",
      "placeholder": "Select Target Group"
    },
    on: {
      "select": _vm.selectedTargetGroupNo
    },
    model: {
      value: (_vm.targetGroupNo),
      callback: function($$v) {
        _vm.targetGroupNo = $$v
      },
      expression: "targetGroupNo"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('targetGroupNo')),
      expression: "errors.has('targetGroupNo')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Target Group field is\n                    required.")]), _vm._v(" "), _c('span', {
    staticClass: "text-danger",
    staticStyle: {
      "font-size": "0.9em"
    }
  }, [_vm._v(_vm._s(_vm.targetGroupListError))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "common-secondary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save")]), _vm._v(" \n                      "), _c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Clear")])])], 1)], 1)])])])], 1)])], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.addmodalShow = false
      }
    },
    model: {
      value: (_vm.addmodalShow),
      callback: function($$v) {
        _vm.addmodalShow = $$v
      },
      expression: "addmodalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v("Selected destinations will be mapped to " + _vm._s(_vm.targetGroupName))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": [_vm.migrateDestinations, function($event) {
        _vm.addmodalShow = false
      }]
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeStatusModal
    }
  }, [_vm._v("Cancel")])])])])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-387c3c93","hasScoped":true}!./src/views/components/groupnew/MigrateDestinations/MigrateDestinations.html
// module id = 1930
// module chunks = 2